import React from 'react';
import PayeeManagementList from './PayeeManagementList';

const ExpensePayeeManagement = () => {
  return <PayeeManagementList />;
};

export default ExpensePayeeManagement;
